//components
import { BasicButton, IconLibrary, ThriveIcon } from 'thrive-components';

//interfaces
import { IPasskeyUsersPanel } from  '@/interfaces/passkeys';

//helpers
import { getPercentageToTwoDecimals } from  '@/helpers/Numbers';



const PasskeyUsersPanel = ({ totalEligibleUsers, legacyAppUserCount, onViewUsersClick} : IPasskeyUsersPanel) => {  
    if (!legacyAppUserCount) { return <></>}
    
    const percentageOfUsers = getPercentageToTwoDecimals(legacyAppUserCount, totalEligibleUsers);

    return(
        <div className="passkey-users-panel thrive-blue-info-panel">
            <div className="top-panel">
                <ThriveIcon 
                    className='user-info-alert'
                    iconName={IconLibrary.INFO}
                    color='var(--thriveBlue'
                    sizeInPx='12'
                />
                    
                <div className='passkey-users-explainer-text'>
                    <span className='boldened-text'>
                        {`${percentageOfUsers}% of users (${legacyAppUserCount}/${totalEligibleUsers}) `}
                    </span>

                    are using an older version on the mobile app and will need to update to use passkeys. We'll send them a push notification to let them know.
                </div>
            </div>

            <BasicButton 
                className='view-users-button'
                content={"View Users"} 
                onButtonClick={onViewUsersClick} 
                ariaLabel={'View a list of users who are using an older version of the mobile app.'} 
            />
        </div>
    )
}

export default PasskeyUsersPanel